const qs = require('qs');
import request from "@/utils/request";
//注册
export function register(data) {
  return request({
    url: 'zwb/app/register',
    method: 'post',
    data
  })
}
//获取验证码
export function registCode() {
  return request({
    url: 'zwb/app/register/sendSmsCaptcha',
    method: 'get'
  })
}

//跟换手机号前获取验证码
export function mobleCaptcha(params) {
  return request({
    url: 'zwb/app/changemob/sendSmsCaptcha',
    method: 'get',
	params
  })
}

//检查手机号是否已注册(注册时)
export function checkMobile(data) {
  return request({
    url: 'zwb/app/checkMobile',
    method: 'post',
    data: qs.stringify(data)
  })
}

// 绑定手机 (检查手机号是否已注册)
export function checkMobiles(params) {
  return request({
    url: 'zwb/app/checkMobile2',
    method: 'get',
    params
  })
}

//获取图形验证码
export function graphicCode(params) {
  return request({
    url: 'zwb/app/captcha.jpg',
    method: 'get',
    params
  })
}

//校验图形码
export function getValidate(params) {
  return request({
    url: 'zwb/app/captcha/validate',
    method: 'get',
    params
  })
}


//发送验证码
export function getCode(params) {
  return request({
    url: 'zwb/app/register/sendSmsCaptcha',
    method: 'get',
    params
  })
}


// 登录
export function login(data) {
  return request({
    url: "/zwb/app/login",
    method: "post",
    data
  });
}

// 获取个人信息-登录后使用
export function getInfo() {
  return request({
    url: "/zwb/app/userInfo",
    method: "get"
  });
}

// 获取个人信息-个人中心展示使用
export function getSelfUserinfo() {
  return request({
    url: "/zwb/app/query/userinfo",
    method: "get"
  });
}


//修改密码时验证用户是否是注册用户,并发送短信验证码
export function authPhoneBind(params) {
  return request({
    url: "/zwb/app/authPhoneBind",
    method: "get",
    params
  });
}

//找回密码前的短信验证
export function checkPhoneVaild(params) {
  return request({
    url: "/zwb/app/checkPhoneVaild",
    method: "get",
    params
  });
}

//找回密码
export function findPassword(params) {
  return request({
    url: "/zwb/app/findPassword",
    method: "get",
    params
  });
}


//找回密码发送邮件
export function retrievesend(data) {
  return request({
    url: "/zwb/app/email/retrievesend",
    method: "post",
    data
  });
}
//邮件修改密码
export function modifypassword(data) {
  return request({
    url: "/zwb/app/email/modifypassword",
    method: "post",
    data
  });
}
//邮箱绑定
export function bindsend(data) {
  return request({
    url: "/zwb/app/email/bindsend",
    method: "post",
    data
  });
}
//短信登录
export function smslogin(data) {
  return request({
    url: "/zwb/app/smslogin",
    method: "post",
    data
  });
}

//短信登录发送验证码
export function SmsCaptcha(params) {
  return request({
    url: "/zwb/app/smslogin/sendSmsCaptcha",
    method: "get",
    params
  });
}


//更换手机号
export function changemodbile(params) {
  return request({
    url: "/zwb/app/account/changemodbile",
    method: "get",
    params
  });
}




// WEBPACK FOOTER //
// ./src/api/user.js